const formSearchBlock = $('.tr-navigation__search-block')
const valSearch = formSearchBlock.find('#search-value')

const searchForm = () => {
  if (formSearchBlock.length >= 1) {
    formSearchBlock.each(function () {
      let typingTimer
      const findedList = $(this).find('.tr-navigation__search-block-finded'),
        circleLoad = $(this).find('.lds-ring'),
        formSearch = $(this).find('.tr-navigation__search-form'),
        listFind = $(this).find('.tr-navigation__search-block-finded .list-find'),
        inputSearch = $(this).find('input#search-value'),
        notificationList = $(this).find('.notification-list'),
        dataTypes = formSearch.attr('data-posts-type')

      formSearch.on('submit', function (e) {
        e.preventDefault()
        window.location.href = `${themeVars.home}?s=${inputSearch.val()}`
      })

      if (inputSearch.val().length > 0) {
        inputSearch.prev('label').addClass('focused')
      }
      inputSearch.focusin(function () {
        $(this).prev('label').addClass('focused')
      }).focusout(function () {
        if ($(this).val().length <= 0) {
          $(this).prev('label').removeClass('focused')
        }
      })
      inputSearch.keyup(function () {
        listFind.html('')
        notificationList.removeClass('show')
        if (!circleLoad.hasClass('show')) {
          circleLoad.addClass('show')
        }
        if ($(this).val().length >= 2) {
          if (!findedList.hasClass('show')) {
            findedList.addClass('show')
          }
          clearTimeout(typingTimer)
          typingTimer = setTimeout(() => {
            notificationList.removeClass('show')
            if (inputSearch.val().length >= 2) {
              $.ajax({
                type: 'GET',
                url: themeVars.ajaxurl,
                data: {
                  action: 'tr_search_posts',
                  nonce: themeVars.wpnonce,
                  val: inputSearch.val(),
                  postType: dataTypes,
                },
                success: function (response) {
                  response ? listFind.html(response) : notificationList.addClass('show')
                  circleLoad.removeClass('show')
                },
                error: function (e) {
                  console.log(e)
                  circleLoad.removeClass('show')
                },
              })
            } else {
              notificationList.addClass('show')
              circleLoad.removeClass('show')
            }
          }, 1000)
        }
      })
    })
  }

  valSearch.val('').focusout()

  $('.tr-navigation a, .tr-navigation button, .tr-header a, .tr-header button').focusin(function () {
    if (!$(this).hasClass('tr-navigation__search-form--btn') && $('.tr-navigation__search-block-finded').hasClass('show')) {
      $('.tr-navigation__search-block-finded').removeClass('show')
      valSearch.val('').focusout()
    }
  })

  $('body').click(function (event) {
    if (!$(event.target).closest('.tr-navigation__search-block-finded.show').length && !$(event.target).is('.tr-navigation__search-block-finded')) {
      $('.tr-navigation__search-block-finded').removeClass('show')
    }
  })
}

export default searchForm
